import {createStyles} from '@material-ui/core';
import {blueColor, greenColor, redColor} from '../../styles/style';

export const style = createStyles({
  mfaStatusIcon: {
    'width': '24px',
    'height': '24px',
    'display': 'inline-block',
    'marginRight': '8px',
    'verticalAlign': 'middle',
    '& svg': {
      width: '100%',
      height: '100%',
    },
  },
  mfaUnavailableIcon: {
    '& *': {
      fill: redColor,
    },
  },
  mfaNotSetIcon: {
    '& *': {
      fillOpacity: 0,
    },
    '& *#countur': {
      stroke: redColor,
    },
    '& *#cross': {
      stroke: redColor,
    }
  },
  mfaViaTotpIcon: {
    '& *': {
      fill: greenColor,
    },
  },
  mfaViaEmailIcon: {
    '& *': {
      fill: blueColor,
    },
  },
});
